import React from "react";
import { Layout, SelfComp } from "../components";

const SelfPage = () => {
  return (
    <>
      <Layout>
        <SelfComp />
      </Layout>
    </>
  );
};

export default SelfPage;
